export default function () {
  jQuery(($) => {
    /**
     * Check if variation is available.
     * This is used if there is multiple attributes.
     * Eg. Red - Small is available. Blue - Small is unavailable.
     * Class gets added if it´s unavailable.
     */
    function checkAvailableVariations() {
      // Get all different attributes. DOM element
      const attributes = $('#sweet-variations-outer').find('.sweet-variations');

      // if there is two attributes or more
      if (attributes && attributes.length > 1) {
        // Loop trough attributes
        for (let i = 0; i < attributes.length; i += 1) {
          // Get the attribute key eg. pa_color and pa_size.
          const attribute = $(attributes[i]).data('attribute');

          // Get all options from matching core WooCommerce select input
          const selectOptions = $(`select#${attribute} option`);
          const optionValues = [];
          selectOptions.each((index, element) => {
            if ($(element).val() && $(element).val().length) {
              // Push option value to array, if option value is not blank.
              optionValues.push($(element).val());
            }
          });

          // Get all links, this represents the attribute variation
          const sweetLinks = $(attributes[i]).find('.choose-variation');
          sweetLinks.each((index, element) => {
            // Check if the attribute still exists in the select option values array
            // Wierd stuff. But this is how you check if something is in an array
            if ($.inArray($(element).data('variation'), optionValues) === -1) {
              $(element).addClass('unavailable-option');
            } else {
              $(element).removeClass('unavailable-option');
            }
          });
        }
      }
    }

    /**
     * Trigger variation changes on sweet variation ul li click
     */
    $(document).on('click', '.sweet-variations .choose-variation:not(.unavailable-option)', (event) => {
      event.preventDefault();
      const element = event.currentTarget;

      // Setup data attributes as const
      const attribute = $(element).data('attribute');
      const variation = $(element).data('variation');
      // const description = $(element).data('description');
      // const price = $(element).data('price');
      // const name = $(element).data('name');
      // const variationID = $(element).data('variation_id');

      // Remove potential other active item and set clicked to active
      $(element).closest('.sweet-variations').find('.choose-variation.active-option').removeClass('active-option');
      $(element).addClass('active-option');

      // Get core WooCommerce select input matching clicked attribute variation
      const select = $(`#${attribute}`);

      // Update the selected value to the chosen size
      $(select).val(variation).change();

      // Run check to set classes to unavailable variations
      checkAvailableVariations();
    });

    // Run check to set classes for unavailable variations
    setTimeout(() => {
      checkAvailableVariations();
    }, 300);

    // Move core WC variation form inside variation dropdown
    jQuery('form.variations_form').appendTo('.sweet-variation-dropdown');

    // Event triggered when variation / all variations if multiple is selected-
    $('form.variations_form').on('show_variation', (event, variation) => {
      $('.module-nf-product > .variation-stock-message').remove();
      $('.module-nf-product > .stock.out-of-stock').remove();

      $(variation.availability_html).prependTo($('.module-nf-product'));
    });


    /**
     * Handle toggling of sweet variation dropdown on button click
     */
    $(document).on('click', '#sweet-variations-opener', (event) => {
      event.preventDefault();
      const element = event.currentTarget;
      $(element).closest('#sweet-variations-outer').find('.sweet-variation-dropdown').toggle();
    });

    /**
     * Handle scrolling to add to cart section and open of sweet variation on shortcode button click
     */
    $(document).on('click', '.select-color-trigger', () => {
      const nfProductModule = $('.module-nf-product');
      if (nfProductModule.length) {
        // const sweetVariationOpener = $(nfProductModule).find('#sweet-variations-opener');
        const sweetVariationDropdown = $(nfProductModule).find('.sweet-variation-dropdown');

        if ($(window).width() > 1078) {
          $('html, body').animate(
            {
              scrollTop: $(nfProductModule).find('.hero-right').scrollTop(),
            },
            400,
          );

          setTimeout(() => {
            $(sweetVariationDropdown).fadeIn();
          }, 440);
        } else {
          $(sweetVariationDropdown).show();
        }
      }
    });

    /**
     * Handle click on shortode add to cart button on singular products,
     * trigger the actual add to cart button and scroll to top
     */
    $(document).on('click', '.add-to-cart-trigger', () => {
      const nfProductModule = $('.module-nf-product');
      if (nfProductModule.length) {
        const addToCartButton = $(nfProductModule).find('.single_add_to_cart_button');
        $(addToCartButton).click();
        setTimeout(() => {
          $('html, body').animate(
            {
              scrollTop: $(nfProductModule).find('.hero-right').scrollTop(),
            },
            900,
          );
        }, 100);
      }
    });
  });
}
